import BaseBehavior from '../../../framework/base/base';
import { debounce } from '../../../shared/utilities/debounce';

const prefs = ['webkit-slider-runnable', 'moz-range'];

const getValStr = (el, p = el.value) => {
	const min = el.min || 0;
	const { max } = el;
	let val;
	if (document.dir === 'rtl') {
		const perc = el.max ? (100 * Math.abs(p - min)) / Math.abs(el.min - max) : p;
		val = 100 - perc + '% 100%,100% 100%,100% 100%';
	} else {
		const perc = el.max ? (100 * (p - min)) / (el.max - min) : p;
		val = perc + '% 100%,100% 100%,100% 100%';
	}

	return val;
};

const setStyle = (bgSize, className) => {
	let str = '';

	prefs.forEach(pref => {
		if (document.dir === 'rtl') {
			str += `html[dir='rtl'] .v2 .${className}::-${pref}-track{background-size:${bgSize}}`;
		} else {
			str += `.v2 .${className}::-${pref}-track{background-size:${bgSize}}`;
		}
	});

	return str;
};

export default class InputSlider extends BaseBehavior {
	constructor(element) {
		super(element);

		this.initDomCache();
		this.styleElement = document.createElement('style');
		document.body.appendChild(this.styleElement);
		this.dom.input = element;
		this.randomClassName = 'input-slider-' + Math.floor(Math.random() * 90000) + 10000;
		this.dom.input.classList.add(this.randomClassName);
		this.setTrackPosition();
		this.addEventListeners();
	}

	addEventListeners() {
		this.addEventListener(this.dom.input, 'input', () => {
			this.setTrackPosition();
		});
	}

	setTextContentToStyle() {
		this.styleElement.textContent = setStyle(getValStr(this.dom.input), this.randomClassName);
	}

	setTrackPosition() {
		debounce(this.setTextContentToStyle.bind(this), 1)();
	}
}
